import flow from 'lodash/flow';
import memoizeOne from 'memoize-one';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { AnalyticsSubject, withFireUiAnalytics } from '@atlassian/jira-analytics-web-react/src';
import type { State } from '@atlassian/jira-issue-view-common-types/src/issue-type';
import { connect } from '@atlassian/jira-issue-view-react-redux';
import {
	modalIsSavingSelector,
	activeWorklogSelector,
	timeTrackingConfigurationSelector,
} from '@atlassian/jira-issue-view-store/src/common/state/selectors/time-tracking-selector';
import { functionWithFFRedux } from '@atlassian/jira-react-redux';
import { timeRemainingSecondsSelector, deleteWorklogRequest, closeModal } from '../../state';
import DeleteModal from './view';

const onConfirmMemo = memoizeOne(
	(stateProps, dispatchDeleteWorklog) =>
		(
			timeRemaining: string,
			isAdjustTimeRemainingChecked: boolean,
			analyticsEvent: UIAnalyticsEvent,
		) => {
			if (stateProps.worklog) {
				dispatchDeleteWorklog(
					stateProps.worklog.id,
					timeRemaining,
					isAdjustTimeRemainingChecked,
					analyticsEvent,
				);
			}
		},
);

export default flow(
	AnalyticsSubject('worklog'),
	withFireUiAnalytics({
		onConfirm: 'confirmDeleteWorklog',
		onCancel: 'cancelDeleteWorklog',
	}),
	// @ts-expect-error - Type instantiation is excessively deep and possibly infinite.
	connect(
		(state: State) => ({
			isDeleting: modalIsSavingSelector(state),
			worklog: activeWorklogSelector(state),
			timeTrackingConfig: timeTrackingConfigurationSelector(state),
			timeRemainingSeconds: timeRemainingSecondsSelector(state),
		}),
		{
			dispatchDeleteWorklog: deleteWorklogRequest,
			onCancel: closeModal,
		},
		(stateProps, { dispatchDeleteWorklog, onCancel }) => ({
			...stateProps,
			onCancel,
			onConfirm: functionWithFFRedux(
				onConfirmMemo(stateProps, dispatchDeleteWorklog),
				(
					timeRemaining: string,
					isAdjustTimeRemainingChecked: boolean,
					analyticsEvent: UIAnalyticsEvent,
				) => {
					if (stateProps.worklog) {
						dispatchDeleteWorklog(
							stateProps.worklog.id,
							timeRemaining,
							isAdjustTimeRemainingChecked,
							analyticsEvent,
						);
					}
				},
			),
		}),
	),
)(DeleteModal);
